import TermsAndConditions from './Terms And Conditions';

export default TermsAndConditions;